import React, { useEffect, useRef, useState } from 'react';
import { DateInput, DateTimePicker, TimeInput } from '@mantine/dates';
import {
	Grid,
	Skeleton,
	Stack,
	NumberInput,
	Select,
	TextInput,
	Alert,
	Textarea,
} from '@mantine/core';
import { getField } from '../../../helpers/screen/backend_helper';
import { useDebouncedValue, useIntersection } from '@mantine/hooks';

export const Field = ({ form, field }) => {
	const [fieldValue, setFieldValue] = useState();
	const [fieldItems, setFieldItems] = useState([]);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	// const [page, setPage] = useState(1);
	const [search, setSearch] = useState('');
	const [debouncedSearch] = useDebouncedValue(search, 300);

	// Fetch field when field changes
	useEffect(() => {
		if (field && search === '') {
			setIsLoading(true);
			setError(null);

			getField({
				field_id: field.field_id,
				// query: {
				// 	page: 1,
				// },
			})
				.then(response => {
					setFieldValue(response);
					if (
						response.field_type.name === 'dropdown' &&
						response.field_items
					) {
						setFieldItems(response.field_items);
					}
				})
				.catch(error => setError(error))
				.finally(() => setIsLoading(false));
		}
	}, [field]);

	// Fetch field items when search changes
	useEffect(() => {
		if (fieldValue?.field_type.name === 'dropdown') {
			setError(null);
			// setPage(1);

			getField({
				field_id: field.field_id,
				query: {
					// page: 1,
					search: debouncedSearch,
				},
			})
				.then(response => {
					if (response.field_items) {
						setFieldItems(response.field_items);
					}
				})
				.catch(error => setError(error));
		}
	}, [debouncedSearch]);

	// Fetch field items when page changes
	// useEffect(() => {
	// 	if (fieldValue?.field_type.name === 'dropdown') {
	// 		setError(null);

	// 		getField({
	// 			field_id: field.field_id,
	// 			query: {
	// 				page: page,
	// 				search: debouncedSearch,
	// 			},
	// 		})
	// 			.then(response => {
	// 				if (response.field_items) {
	// 					setFieldItems([...fieldItems, ...response.field_items]);
	// 				}
	// 			})
	// 			.catch(error => setError(error));
	// 	}
	// }, [page]);

	if (isLoading) {
		return (
			<Grid.Col span={field?.size || 4}>
				<Stack spacing={8}>
					<Skeleton height={17.359} width='20%' />
					<Skeleton height={36} />
				</Stack>
			</Grid.Col>
		);
	}

	if (error) {
		return (
			<Grid.Col span={field?.size || 4}>
				<Alert color='red' title='Error al cargar el campo'>
					{typeof error === 'string'
						? error
						: error.message
						? error.message
						: 'Ocurrió un error al cargar el campo'}
				</Alert>
			</Grid.Col>
		);
	}

	if (!fieldValue) {
		return null;
	}

	return (
		<Grid.Col span={field?.size || 4}>
			{fieldValue?.field_type?.name === 'text' && (
				<TextInput
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					placeholder={`Ingrese ${fieldValue?.name?.toLowerCase()}`}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'number' && (
				<NumberInput
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'date' && (
				<DateInput
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'datetime' && (
				<DateTimePicker
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'time' && (
				<TimeInput
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'dropdown' && (
				<Select
					searchable
					clearable
					searchValue={search}
					onSearchChange={setSearch}
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					placeholder='Seleccione una opción'
					data={
						fieldItems?.map(item => ({
							value: item._id,
							label: item.name,
						})) || []
					}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
			{fieldValue?.field_type.name === 'text-block' && (
				<Textarea
					label={fieldValue?.name}
					id={fieldValue?.field_id}
					required={!field.optional || false}
					{...form.getInputProps(fieldValue?.name)}
				/>
			)}
		</Grid.Col>
	);
};
